import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

import { getUISiteId } from '../../site-detail/store/selectors/ui';
import { AppState } from '../store/app-state';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private store: Store<AppState>) {}

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.url.includes('/token')) {
            return next.handle(req);
        }

        return this.store.select(getUISiteId).pipe(
            first(),
            switchMap((siteOID) => {
                const params = req.params.set('siteOID', siteOID);
                const modifiedReq = siteOID ? req.clone({ params }) : req;
                return next.handle(modifiedReq);
            }),
        );
    }
}
